import {EntityKey as FlatEntityKey} from '../entity/entity';
import {EntityKey as FullEntityKey} from '../entity/entity-key';

export class EntityKeyUtils {

  static convertToFullEntityKey(input: FlatEntityKey): FullEntityKey {
    const entityKey = new FullEntityKey();
    entityKey.entityRevision = input.entityRevision.toString();
    entityKey.entityId = input.entityId;
    entityKey.entityType = input.entityName;
    return entityKey;
  }

  static convertToFlatEntityKey(input: FullEntityKey): FlatEntityKey {
    const entityKey = new FlatEntityKey();
    entityKey.entityRevision = +input.entityRevision;
    entityKey.entityId = input.entityId;
    entityKey.entityName = input.entityType;
    return entityKey;
  }

}
